module.exports = __webpack_public_path__ + "5a63ce4575258cfd233fd935817bc880.woff2";